import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const SUGGESTIONS = [
  { to: '/places',     label: 'Places',     hint: 'Restaurants, bars and stays' },
  { to: '/events',     label: 'Events',     hint: 'What is on this week' },
  { to: '/activities', label: 'Activities', hint: 'Things to do and try' },
];

export default function NotFound() {
  return (
    <div className="nf-page">
      <div className="nf-inner">
        <div className="nf-code" aria-hidden="true">404</div>
        <h1 className="nf-title">This page has wandered off</h1>
        <p className="nf-text">
          The link may be broken, or the page may have moved. Try one of these instead.
        </p>

        <div className="nf-links">
          {SUGGESTIONS.map((s) => (
            <Link key={s.to} to={s.to} className="nf-card">
              <span className="nf-card-label">{s.label}</span>
              <span className="nf-card-hint">{s.hint}</span>
            </Link>
          ))}
        </div>

        <div className="nf-actions">
          <Link to="/" className="nf-btn nf-btn-primary">Back to home</Link>
          <Link to="/search" className="nf-btn">Search Zénde</Link>
        </div>
      </div>
    </div>
  );
}
